export const beforePrintHooks = new Set();
export const afterPrintHooks = new Set();
export const registerPrintHandler = (before, after = null) => {
    beforePrintHooks.add(before);
    afterPrintHooks.add(after);
};
export const unregisterPrintHandler = (before, after) => {
    beforePrintHooks.delete(before);
    afterPrintHooks.delete(after);
};

const executeBefore = () => {
    beforePrintHooks.forEach((fn) => fn && fn());
};
const executeAfter = () => {
    afterPrintHooks.forEach((fn) => fn && fn());
};
window.onbeforeprint = executeBefore;
window.onafterprint = executeAfter;

// matchMedia doesn't seem to be working
// still keeping it in place
// window.matchMedia('print').addListener((mql) => {
//     if (mql.matches) {
//         beforePrintHooks.forEach((fn) => fn && fn());
//     } else {
//         afterPrintHooks.forEach((fn) => fn && fn());
//     }
// });
